// ResultMetaBar — 26px footer strip under the VirtualTable.
//
// Replaces the dead strip's footer half. Operator-grade signal: count, sort,
// backend, latency, cache state, cursor. No vanity histograms.

import type { CSSProperties, ReactNode } from 'react';

export interface ResultMetaBarProps {
  count: number | null;
  total?: number | null;
  sortLabel?: string;
  backend?: 'postgres-fts' | 'opensearch-hybrid' | 'fixture' | 'pgvector+postgis';
  latencyMs?: number;
  fromCache?: boolean;
  hasMore?: boolean;
  rightSlot?: ReactNode;
}

export function ResultMetaBar({
  count,
  total,
  sortLabel,
  backend,
  latencyMs,
  fromCache,
  hasMore,
  rightSlot,
}: ResultMetaBarProps) {
  const left: string[] = [];
  if (count != null) left.push(`${count.toLocaleString()} ROWS`);
  if (total != null) left.push(`OF ${total.toLocaleString()}`);
  if (sortLabel) left.push(`SORT=${sortLabel}`);
  if (backend) left.push(`SRC=${backend.replace('-', ' ')}`);
  if (latencyMs != null) left.push(`${Math.round(latencyMs)}MS`);
  if (fromCache) left.push('CACHED');
  if (hasMore) left.push('MORE…');

  return (
    <div data-component="ResultMetaBar" style={containerStyle}>
      <span style={textStyle}>{left.join(' · ')}</span>
      <span>{rightSlot}</span>
    </div>
  );
}

const containerStyle: CSSProperties = {
  height: 26,
  padding: '0 12px',
  borderTop: '1px solid var(--bd)',
  background: 'var(--bg-pane)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
};

const textStyle: CSSProperties = {
  fontSize: 10,
  fontFamily: 'var(--mono)',
  color: 'var(--fg-3)',
  letterSpacing: 0.4,
  textTransform: 'uppercase',
  fontVariantNumeric: 'tabular-nums',
};
